import { gql } from "@apollo/client";
import { COLOR_BLACK } from "helpers/colors";
import useData from "helpers/useData";
import useFullscreenState from "helpers/useFullscreenState";
import Dialog from "molecules/Dialog";
import React from "react";

import HighlightPlayer, { HighlightPlayerFragment } from "./HighlightPlayer";
import VideoPlayerDialogFooter from "./VideoPlayerDialogFooter";

// index, total, onPrevious and onNext are for stepping through a list of highlights; leave them out for a single one.
export default function HighlightPlayerDialog({ open, onClose, eventId, index, total, onPrevious, onNext }) {
  const [data] = useData(
    gql`
      query HighlightPlayerDialog($eventId: ID!) {
        event(id: $eventId) {
          id
          ...HighlightPlayerFragment
        }
      }
      ${HighlightPlayerFragment}
    `,
    { eventId },
    // eventId is briefly missing while the next page of a list loads
    { skip: !open || !eventId },
  );
  const [fullscreen] = useFullscreenState();

  return (
    <Dialog
      noPadding
      hideCloseButton
      open={open}
      onClose={onClose}
      inverse
      {...(fullscreen
        ? { fullHeight: true, fullWidth: true }
        : {
            mediumWidth: true,
          })}
      PaperProps={{
        style: {
          backgroundColor: COLOR_BLACK,
        },
      }}
    >
      {/* key: a fresh player for each highlight, so playback state doesn't carry over */}
      <HighlightPlayer
        key={eventId}
        event={data?.event}
        eventId={eventId}
        // inside the player, so it stays right under the header when the video is centred on a tall screen
        footer={
          <VideoPlayerDialogFooter
            index={index}
            total={total}
            onPrevious={onPrevious}
            onNext={onNext}
            onClose={onClose}
          />
        }
      />
    </Dialog>
  );
}
